import "./css/SigningFlow.css";

export default function GuardianRejected({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content guardian-page">

                <div className="warning-icon warning-icon-danger" />

                <h3 className="guardian-title">
                    Thank You
                </h3>

                <p className="guardian-text">
                    Your response has been recorded.
                </p>
               
                <p className="guardian-text">
                    You may now close this window.
                </p>

            </div>

            <div className="page-footer">

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}